import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RowMetadata from '@app/models/row-metadata';

@Injectable({
  providedIn: "root"
})
export class MetadataService {
  constructor(private http: HttpClient) {}

  /**
   * Gets metadata for an single entity
   * @param entityTypeName
   * @param id
   */
  public getMetadata(entityTypeName: string, id: number) {
    return this.http.get<RowMetadata>(`system/entity/metadata/${entityTypeName}/${id}`);
  }
}
